{
  "ascending": "artan sırada",
  "ascendingSort": "{columnName} sütuna göre artan düzende sırala",
  "collapse": "Daralt",
  "columnSize": "{value} piksel",
  "descending": "azalan sırada",
  "descendingSort": "{columnName} sütuna göre azalan düzende sırala",
  "expand": "Genişlet",
  "resizerDescription": "Yeniden boyutlandırmak için Enter'a basın",
  "select": "Seç",
  "selectAll": "Tümünü Seç",
  "sortable": "Sıralanabilir sütun"
}
